"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.SIGNATURE_TYPE_ETH = void 0;
const StreamMessage_1 = __importDefault(require("./StreamMessage"));
const MessageRef_1 = __importDefault(require("./MessageRef"));
const MessageID_1 = __importDefault(require("./MessageID"));
const EncryptedGroupKey_1 = __importDefault(require("./EncryptedGroupKey"));
const Serializer_1 = require("../../Serializer");
const ValidationError_1 = __importDefault(require("../../errors/ValidationError"));
const VERSION = 32;
exports.SIGNATURE_TYPE_ETH = 2;
/* eslint-disable class-methods-use-this */
class StreamMessageSerializerV32 extends Serializer_1.Serializer {
    toArray(streamMessage) {
        return [
            VERSION,
            streamMessage.messageId.toArray(),
            streamMessage.prevMsgRef ? streamMessage.prevMsgRef.toArray() : null,
            streamMessage.messageType,
            streamMessage.contentType,
            streamMessage.encryptionType,
            streamMessage.groupKeyId,
            streamMessage.serializedContent,
            streamMessage.newGroupKey ? streamMessage.newGroupKey.serialize() : null,
            exports.SIGNATURE_TYPE_ETH,
            streamMessage.signature,
        ];
    }
    fromArray(arr) {
        const [_version, messageIdArr, prevMsgRefArr, messageType, contentType, encryptionType, groupKeyId, serializedContent, serializedNewGroupKey, signatureType, signature] = arr;
        if (signatureType !== exports.SIGNATURE_TYPE_ETH) {
            throw new ValidationError_1.default(`Unsupported signature type: ${signatureType}`);
        }
        return new StreamMessage_1.default({
            messageId: MessageID_1.default.fromArray(messageIdArr),
            prevMsgRef: prevMsgRefArr ? MessageRef_1.default.fromArray(prevMsgRefArr) : null,
            content: serializedContent,
            messageType,
            contentType,
            encryptionType,
            groupKeyId,
            newGroupKey: serializedNewGroupKey ? EncryptedGroupKey_1.default.deserialize(serializedNewGroupKey) : null,
            signature
        });
    }
}
exports.default = StreamMessageSerializerV32;
StreamMessage_1.default.registerSerializer(VERSION, new StreamMessageSerializerV32());
//# sourceMappingURL=StreamMessageSerializerV32.js.map